import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics';
import { syntheticsReaderContracts } from '../constants';
export var GetMarkets = createPlugin({
    protocol: 'SyntheticsReader',
    type: 'GETTER',
    method: 'getMarkets',
    supportedContracts: syntheticsReaderContracts,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    dataStore: new FctAddress({}),
                    start: new FctValue({}),
                    end: new FctValue({}),
                },
            },
            output: {
                'marketData_tuple[]': {
                    marketToken: new FctAddress({}),
                    indexToken: new FctAddress({}),
                    longToken: new FctAddress({}),
                    shortToken: new FctAddress({}),
                },
            },
        });
    },
});
